import Image from 'next/image'

import type { Media } from '@/payload-types'

type Formato = 'card' | 'article' | 'hero'

export const mediaDoc = (valore: unknown): Media | null =>
  valore && typeof valore === 'object' && 'url' in (valore as Media) ? (valore as Media) : null

/** Payload restituisce URL assoluti: qui servono relativi, per next/image. */
const relativo = (url: string): string => url.replace(/^https?:\/\/[^/]+/, '')

/** Sceglie il formato derivato richiesto, con ricaduta sull'originale. */
const sorgente = (media: Media, formato: Formato) => {
  const derivato = media.sizes?.[formato]
  if (derivato?.url && derivato.width && derivato.height) {
    return { url: relativo(derivato.url), width: derivato.width, height: derivato.height }
  }
  return {
    url: media.url ? relativo(media.url) : '',
    width: media.width ?? 1600,
    height: media.height ?? 1000,
  }
}

export function MediaImage({
  media,
  formato = 'card',
  sizes,
  className,
  priority = false,
  fill = false,
}: {
  media: Media
  formato?: Formato
  sizes?: string
  className?: string
  priority?: boolean
  fill?: boolean
}) {
  const { url, width, height } = sorgente(media, formato)
  if (!url) return null

  const alt = media.alt ?? ''
  const comuni = { src: url, className, priority, sizes: sizes ?? '100vw' }

  return fill ? (
    <Image {...comuni} alt={alt} fill />
  ) : (
    <Image {...comuni} alt={alt} width={width} height={height} />
  )
}

/**
 * Immagine di una pagina fissa: quella scelta nel pannello, oppure quella
 * di serie se il campo è vuoto. Evita che una pagina resti senza apertura
 * mentre la redazione decide che cosa metterci.
 */
export function ImmaginePagina({
  media,
  ricaduta,
  formato = 'hero',
  sizes,
  priority = false,
}: {
  media: unknown
  ricaduta: { src: string; alt: string; width: number; height: number }
  formato?: Formato
  sizes?: string
  priority?: boolean
}) {
  const doc = mediaDoc(media)
  if (doc) return <MediaImage media={doc} formato={formato} sizes={sizes} priority={priority} />

  return (
    <Image
      src={ricaduta.src}
      alt={ricaduta.alt}
      width={ricaduta.width}
      height={ricaduta.height}
      sizes={sizes}
      priority={priority}
    />
  )
}
